export default __webpack_public_path__ + "static/media/hero.7e89437f.jpg";